import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        // we init with resources
        resources: {
            for_english: {
                translations: {
                    welcome: 'Welcome',
                    terms: `Terms and conditions`,
                    sellerTermsAndConditions: `
                    ✅ Upload Your Car   
                    The seller registers the car on the platform and provides all relevant details, including a self-assessment of the car’s condition and any damages.   
                    Photos and documents such as the service book and inspection report are uploaded. 
                     
                    ✅ Valuation & Reserve Price   
                    Carzaar helps the seller determine a competitive reserve price using AI-based valuation and auction insights.   
                    The seller approves the reserve price before the car is listed for auction. 
                     
                    ✅ 7-Day Exclusivity   
                    The seller agrees that the car will be exclusive to Carzaar for 7 days, meaning it can only be sold through our platform during this period.   
                    If the seller withdraws from the sales process during this time, a fee of 600 SEK (excl. VAT) applies.   
                    If the reserve price is met and the seller refuses to sell the car, a fee of 5,000 SEK (excl. VAT) applies. 
                     
                    ✅ Auction & Bidding   
                    The car is listed on Carzaar, and the auction runs for up to two days.   
                    If the reserve price is not met, the car may be relisted until the best possible bid is obtained within the 7-day exclusivity period. 
                     
                    ✅ Inspection at Carspect   
                    Once the seller accepts a bid, the car must be inspected by an independent third party (Carspect).   
                    Carzaar covers the inspection cost if the sale is completed.   
                    If the inspection report significantly differs from the seller’s self-assessment and the buyer cancels the purchase, the seller will bear the inspection cost. 
                     
                    ✅ Final Approval & Payment   
                    After the inspection, the buyer reviews the inspection report and decides whether the car matches the seller’s description.   
                    If no major discrepancies are found, the sale proceeds, and the seller receives payment after deducting the inspection cost. 
                     
                    ✅ Vehicle Handover   
                    Carzaar arranges pickup of the car from the seller’s specified location.   
                    Ownership transfer is handled by Carzaar through the Swedish Transport Authority, and any existing loans are settled directly with the bank before payment is made to the seller.`,
                    ambassadorTermsAndConditions: `
                    
                    ☑ **Ambassador’s Role** 
                    - Your main task as an ambassador is to **recruit sellers** and drive traffic to Carzaar’s platform. 
                    - You will only be paid for cars that are **sold through Carzaar and for which full payment has been received**. 
                    
                    ☑ **Commission & Compensation** 
                    - You will receive **1,000 SEK including VAT** per car that you have recruited and that is sold through the platform. 
                    - **Bonus System:** 
                      - **Silver:** 1,200 SEK per sold car (after 20 cars/month). 
                      - **Gold:** 1,500 SEK per sold car (after 45 cars/month). 
                    - Compensation is paid **monthly** via invoice. 
                    
                    ☑ **Time Limit for Commission** 
                    - The ambassador is entitled to commission for sellers who register via their link and complete a sale **within 12 months** from the registration date. 
                    - If the seller completes a sale after 12 months without active engagement from the ambassador, no commission is granted. 
                    
                    ☑ **F-Tax & Invoicing** 
                    - Ambassadors **must have F-tax** and can only invoice Carzaar. 
                    - Carzaar **cannot** pay commissions to private individuals or personal bank accounts. 
                    
                    ☑ **Marketing & Advertising** 
                    - Ambassadors are allowed to promote Carzaar, including via **paid advertisements**. 
                    - **All advertisements must be approved by Carzaar before publishing**. 
                    - Ambassadors **must not use misleading or false claims** in their marketing. 
                    
                    ☑ **Confidentiality & Customer Information** 
                    - Ambassadors **must not share or sell information** about sellers they have recruited. 
                    - All data is handled in accordance with GDPR and Carzaar’s privacy policy. 
                    
                    ☑ **Termination of Cooperation** 
                    - Carzaar has the right to **terminate cooperation with 30 days' notice**. 
                    - If an ambassador violates the agreement, Carzaar may immediately terminate the cooperation and deny future commissions. `,
                    buyerTermsAndConditions: `
                    
                    ☑ Buyer’s Role & Responsibility
                    
                    - Only corporate customers are allowed to purchase cars via Carzaar – private individuals are not permitted.
                    
                    - The buyer is responsible for ensuring that all registered details are accurate.
                    
                    - Only authorized representatives may participate in bidding and purchasing vehicles.
                    
                    📝 Terms & Conditions
                    
                    This agreement regulates the terms for buyers participating in Carzaar’s platform and auctions. By placing bids and completing a purchase, the buyer agrees to the following conditions:
                    
                    1. **Binding Bidding** – All bids are binding. If the buyer wins the auction, they are obligated to complete the transaction and make full payment.
                    
                    2. **Inspection and Handover** – After the auction, a third-party inspection is conducted. The buyer may review the test report but can only cancel the purchase if significant defects are discovered, as determined by Carzaar.
                    
                    3. **Payment Terms** – Payment is due upon vehicle allocation after the auction ends. If payment is not made, Carzaar may restrict the buyer from future purchases.
                    
                    4. **Disputes & Claims** – Any disputes must first be addressed in consultation with Carzaar and will be handled according to Swedish law.
                    
                    5. **Confidentiality** – Buyers may not contact sellers directly; all communication must go through Carzaar.
        
                    6. **Transaction Cancellation** – If a seller cancels the transaction after the reserve price is met, Carzaar is not responsible for any losses incurred by the buyer but will seek to resolve the issue.
                    
                    7. **Limited Liability** – Carzaar holds no responsibility for the vehicle's condition once the buyer has accepted it based on the inspection report.`,
                },
            },
            for_mandarin: {
                translations: {
                    welcome: 'Välkommen',
                    terms: `Villkor`,
                    sellerTermsAndConditions: ` 
                    Säljaren registrerar bilen på plattformen och fyller i all relevant information, inklusive en självuppskattning av bilens skick och eventuella skador.   
                    Bilder och dokument som servicebok och besiktningsprotokoll laddas upp. 
                     
                    ✅ Värdering & Reservationspris   
                    Carzaar hjälper säljaren att fastställa ett marknadsmässigt reservationspris genom en AI-baserad värdering samt insikter från auktioner.   
                    Säljaren godkänner reservationspriset innan bilen går ut på auktion. 
                     
                    ✅ Exklusivitet i 7 dagar   
                    Säljaren godkänner att bilen är exklusiv för Carzaar i 7 dagar, vilket innebär att den endast kan säljas genom vår plattform under denna period.   
                    Om säljaren väljer att avbryta försäljningsprocessen under dessa 7 dagar debiteras en avgift på 600 SEK (exkl. moms). 
                     
                    ✅ Auktion & Budgivning   
                    Bilen publiceras på Carzaar och auktionen pågår i upp till två dagar.   
                    Om reservationspriset inte uppnås, kan bilen listas igen tills bästa möjliga bud erhålls inom 7-dagarsperioden. 
                     
                    ✅ Inspektion hos Carspect   
                    När säljaren accepterar ett bud måste bilen inspekteras av en oberoende tredjepart (Carspect).   
                    Carzaar står för kostnaden för inspektionen om försäljningen genomförs.   
                    Om inspektionsrapporten skiljer sig väsentligt från säljarens självuppskattning och köparen avbryter köpet, får säljaren själv stå för inspektionskostnaden.   
                    Oavsett utfall betalar säljaren först inspektionsavgiften, men om affären genomförs återbetalas summan i samband med att Carzaar överför pengarna för bilen. 
                     
                    ✅ Slutgodkännande & Betalning   
                    Efter inspektionen får köparen möjlighet att godkänna bilens skick.   
                    Om inga allvarliga avvikelser upptäcks genomförs försäljningen, och säljaren får pengarna utbetalda efter avdrag för inspektionskostnaden (som läggs till köparens slutpris). 
                     
                    ✅ Utlämning av bilen   
                    Carzaar ordnar hämtning av bilen från säljarens angivna plats.   
                    Ägarbytet hanteras av Carzaar via Transportstyrelsen och eventuella lån löses direkt med banken innan pengarna betalas ut till säljaren. 
                     
                    
                    Avtalsvillkor 
                    
                     
                    1. **Registrering och uppladdning av bil**   
                       Säljaren är ansvarig för att all information som anges om fordonet är korrekt och sanningsenlig.   
                       Carzaar har rätt att neka en försäljning om uppgifterna bedöms vara missvisande. 
                     
                    2. **Exklusivitet**   
                       När säljaren laddar upp sin bil på Carzaar ingår denne ett exklusivitetsavtal på 7 dagar, vilket innebär att fordonet endast får säljas via Carzaar under denna period.   
                       Om säljaren avbryter försäljningsprocessen under exklusivitetsperioden debiteras en avgift på **600 SEK (exkl. moms).**   
                       Om reservationspriset uppnås och säljaren ändå väljer att inte sälja sin bil debiteras en avgift på **5 000 SEK (exkl. moms).** 
                     
                    3. **Auktion & Försäljningsprocess**   
                       Auktionen pågår normalt i två dagar men kan förlängas inom exklusivitetsperioden om reservationspriset inte uppnås.   
                       Säljaren har möjlighet att acceptera eller avböja slutbudet.   
                     
                    4. **Inspektion & Ansvar**   
                       Säljaren måste låta bilen inspekteras av Carzaars partner (Carspect) innan försäljningen slutförs.   
                       Om inspektionsprotokollet visar betydande skillnader från säljarens självuppskattning har köparen rätt att justera sitt bud eller avstå från köpet.   
                       Carzaar står för inspektionskostnaden vid genomförd försäljning, men om köparen avbryter köpet på grund av väsentliga avvikelser i bilens skick, får säljaren stå för inspektionskostnaden. 
                     
                    5. **Betalning & Ägarbyte**   
                       När affären är slutförd betalar Carzaar ut pengarna till säljaren efter avdrag för eventuella avgifter.   
                       Ägarbytet hanteras av Carzaar och eventuella lån löses direkt med banken innan utbetalning. 
                     
                    6. **Tvister & Ansvarsfriskrivning**   
                       Carzaar ansvarar för hela processen tills köparen godkänner inspektionsprotokollet och tar emot bilen. Därefter anses affären slutförd.   
                       Eventuella tvister hanteras enligt svensk lag.`,
                    ambassadorTermsAndConditions: `
                    
                    ☑ **Ambassadörens Roll** 
                    - Din huvuduppgift som ambassadör är att **rekrytera säljare** och skapa trafik till Carzaars plattform. 
                    - Du får endast betalt för bilar som **säljs via Carzaar och där full betalning har mottagits**. 
                    
                    ☑ **Provision & Ersättning** 
                    - Du får **1 000 SEK inklusive moms** per bil som du har rekryterat och som säljs via plattformen. 
                    - **Bonussystem:** 
                      - **Silver:** 1 200 SEK per såld bil (efter 20 bilar/månad). 
                      - **Guld:** 1 500 SEK per såld bil (efter 45 bilar/månad). 
                    - Ersättningen betalas ut **månadsvis** mot faktura. 
                    
                    ☑ **Tidsgräns för Provision** 
                    - Ambassadören har rätt till provision för säljare som registrerat sig via deras länk och genomfört en försäljning **inom 12 månader** från registreringsdatum. 
                    - Om säljaren genomför en försäljning efter 12 månader utan aktivt engagemang från ambassadören, utgår ingen provision. 
                    
                    ☑ **F-skatt & Fakturering** 
                    - Ambassadörer **måste ha F-skatt** och kan endast fakturera Carzaar. 
                    - Carzaar kan **inte** betala ut provision till privatpersoner eller privata bankkonton. 
                    
                    ☑ **Marknadsföring & Annonsering** 
                    - Ambassadörer får marknadsföra Carzaar, inklusive via **betalda annonser**. 
                    - **Alla annonser måste godkännas av Carzaar innan publicering**. 
                    - Ambassadörer får **inte använda vilseledande eller falska påståenden** i sin marknadsföring. 
                    
                    ☑ **Sekretess & Kundinformation** 
                    - Ambassadörer får **inte dela eller sälja information** om säljare de rekryterat. 
                    - All data hanteras enligt GDPR och Carzaars sekretesspolicy. 
                    
                    ☑ **Uppsägning av Samarbete** 
                    - Carzaar har rätt att **avsluta samarbetet med 30 dagars varsel**. 
                    - Om en ambassadör bryter mot avtalet kan Carzaar omedelbart säga upp samarbetet och neka framtida provisioner. `,
                    buyerTermsAndConditions: `
                    
                    ☑ Köparens Roll & Ansvar 
                    
                    - Endast företagskunder kan köpa bilar via Carzaar – privatpersoner är ej tillåtna. 
                    
                    - Köparen ansvarar för att alla registrerade uppgifter är korrekta. 
                    
                    - Endast auktoriserade representanter får delta i budgivning och köp av bilar. 
                    
                    ☑ Budgivning & Köp 
                    
                    - Alla bud är bindande, och vid vinst av en auktion är köparen skyldig att genomföra köpet. 
                    
                    - Om reservationspriset uppnås är säljaren skyldig att sälja bilen, och köparen är skyldig att genomföra affären. 
                    
                    - Om säljaren avbryter affären och vägrar lämna över bilen trots uppnått reservationspris, kan Carzaar ej hållas ansvarigt för detta men kommer att arbeta för att ersätta köparen med ett likvärdigt fordon eller återbetala eventuell förskottsbetalning. 
                    
                    ☑ Betalning & Inspektion 
                    
                    - Betalning sker vid tilldelning av bilen när auktionen stängs. 
                    
                    - Carzaar bokar inspektion av bilen genom en tredjepart (Carspect) tillsammans med köparen, vilket normalt tar 1–3 arbetsdagar. 
                    
                    - Efter att inspektionen har utförts får köparen ta del av testprotokollet och jämföra det med säljarens självuppskattning. 
                    
                    - Köparen kan inte utan vidare dra sig ur affären om bilen inte stämmer exakt överens med självuppskattningen. Endast allvarliga fel som påverkar bilens värde väsentligt kan leda till hävning av köpet. 
                    
                    - Carzaar förbehåller sig rätten att bedöma vad som räknas som ett allvarligt fel och avgöra om affären kan hävas eller om köparen måste genomföra köpet. 
                    
                    ☑ Överlämning av Bilen 
                    
                    - När betalning är bekräftad och inspektionen genomförd bokas hämtning av bilen. 
                    
                    - Bilen överlämnas vid Carzaars inspektionsstation eller via transport (beroende på köparens önskemål). 
                    
                    - Om köparen inte fullföljer betalningen i tid kan en straffavgift tillkomma eller affären hävas. 
                    
                    ☑ Garantier & Ansvar 
                    
                    - Carzaar garanterar att säljaren är den rättmätiga ägaren och att bilen kan överlåtas lagligt. 
                    
                    - Om säljaren vägrar att genomföra affären efter accepterat bud, har Carzaar inget ansvar gentemot köparen, men kommer att agera för att lösa situationen genom att erbjuda ett likvärdigt fordon eller återbetalning. 
                    
                    ☑ Tvister & Reklamationer 
                    
                    - Eventuella tvister mellan köpare och säljare hanteras via Carzaar enligt svensk lagstiftning. 
                    
                    ☑ Sekretess & Datahantering 
                    
                    - Köparen får inte kontakta säljaren direkt – all kommunikation sker via Carzaar. 
                    
                    - Carzaar förbehåller sig rätten att neka köpare som bryter mot avtalet eller missbrukar plattformen. 
                    
                    📝 Avtalsvillkor 
                    
                    Detta avtal reglerar villkoren för köpare som deltar i Carzaars plattform och auktioner. Genom att delta i budgivning och slutföra ett köp godkänner köparen följande villkor: 
                    
                    1. **Bindande Budgivning** – Alla bud som läggs är bindande. Om köparen vinner auktionen är denne skyldig att genomföra affären och fullfölja betalningen. 
                    
                    2. **Inspektion och Överlämning** – Efter avslutad auktion genomförs en inspektion av en oberoende part. Köparen får granska testprotokollet men kan endast avstå från köpet om allvarliga defekter upptäcks, enligt Carzaars bedömning. 
                    
                    3. **Betalningsvillkor** – Betalning sker vid tilldelning av bilen efter avslutad auktion. Om betalning uteblir kan Carzaar neka köparen framtida köp. 
                    
                    4. **Tvister och Reklamationer** – Eventuella tvister hanteras enligt svensk lag och ska först lösas i samråd med Carzaar. 
                    
                    5. **Sekretess** – Köpare får inte kontakta säljare direkt, utan all kommunikation sker via Carzaar. 
                    
                    6. **Avbruten Affär** – Om en säljare avbryter affären efter reservationspris uppnåtts, ansvarar Carzaar inte för skador eller kostnader för köparen men strävar efter att lösa situationen. 
                    
                    7. **Begränsat Ansvar** – Carzaar tar inget ansvar för fordonets skick efter att köparen godkänt det utifrån testprotokollet. `,
                },
            },
        },
        fallbackLng: 'for_english',
        debug: false,

        // have a common namespace used around the full app
        ns: ['translations'],
        defaultNS: 'translations',

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ',',
        },

        react: {
            wait: true,
        },
    })

export default i18n
